import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=40f8711a&scoped=true"
import script from "./complaintList.vue?vue&type=script&lang=js"
export * from "./complaintList.vue?vue&type=script&lang=js"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=40f8711a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f8711a",
  null
  
)

export default component.exports